import React, { useMemo } from "react";
import {
  MdOutlineRemoveCircleOutline,
  MdOutlineAddCircleOutline,
} from "react-icons/md";
import { useDispatch } from "react-redux";

import { imageUrl } from "../../config/apiUrl";
import { addItemToCart, removeItemFromCart } from "../../redux/cart/cart";
import classes from "./cartItem.module.css";

const CartItem = ({ data, cardPrice, removeActions }) => {
  const dispatch = useDispatch();
  const isCollection = typeof data?.cards === "object";
  const photo = isCollection ? data?.cards[0]?.photo : data?.photo;

  // calculatePrice
  const calculatePrice = useMemo(() => {
    if (isCollection) {
      return data?.cards?.length * cardPrice * data?.quantity;
    } else {
      return cardPrice * data?.quantity;
    }
  }, [data]);

  return (
    <div className={classes?.cartContainer}>
      <div className={classes?.cartImg}>
        <img src={imageUrl(photo)} />
      </div>
      <p className="maxLine1">{data?.name}</p>
      <p>{isCollection ? "Collection" : "Single"}</p>
      <p>${parseFloat(calculatePrice).toFixed(2)}</p>
      {!removeActions && (
        <div className={classes?.quantityContainer}>
          <div
            className={classes?.action}
            onClick={() => dispatch(removeItemFromCart(data))}
          >
            <MdOutlineRemoveCircleOutline />
          </div>
          <span>{data?.quantity}</span>
          <div
            className={classes?.action}
            onClick={() => dispatch(addItemToCart(data))}
          >
            <MdOutlineAddCircleOutline />
          </div>
        </div>
      )}
    </div>
  );
};

export default CartItem;
